// src/pages/BedMaster.jsx
import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  MenuItem,
  Snackbar,
  Alert,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableSortLabel,
  TablePagination,
  Box,
  TableContainer,
  Paper,
  Button,
} from "@mui/material";
import { API_BASE_URL } from "../../../constant/constant";
import { decrypt } from "../../../components/cryptoUtil";

// export libs
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
//import * as XLSX from "xlsx";

import XLSX from "xlsx-js-style";
import { Heading } from "../../componenet/heading";





// Sorting helpers
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilized = array.map((el, idx) => [el, idx]);
  stabilized.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilized.map((el) => el[0]);
}

const BedAvailability = () => {

const formatDateTime = (dateObj = new Date()) => {
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = dateObj.toLocaleString("en-US", { month: "short" }); // Jan, Feb, Mar...
  const year = dateObj.getFullYear();

  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
 const seconds = String(dateObj.getSeconds()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};




  const [beds, setBeds] = useState([]);
  const [bedStatusOptions, setBedStatusOptions] = useState([]);
  const [bedStatus, setBedStatus] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("ward_name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const tableRef = useRef();

  let decryptedData = {};
  try {
    const tokenData = localStorage.getItem("tokenData");
    decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
  } catch (e) {
    console.warn("Failed to decrypt tokenData", e);
    decryptedData = {};
  }
  const token = localStorage.getItem("token") || "";
  const hospitalId = decryptedData.softsubgroup || "";

  // ------------------ Fetch data ------------------
  useEffect(() => {
    const fetchBeds = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/hospital/beds/${hospitalId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (Array.isArray(data)) setBeds(data);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchBedStatusOptions = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/hospital/bed-status`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setBedStatusOptions(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBeds();
    fetchBedStatusOptions();
  }, [hospitalId, token]);

  // ------------------ Filtering ------------------
  const filteredBeds = bedStatus
    ? beds.filter((b) => b.bed_status === bedStatus)
    : beds;

  const visibleRows = stableSort(
    filteredBeds,
    getComparator(order, orderBy)
  ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // ------------------ Handlers ------------------
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ------------------ Export Functions ------------------
  // const getDateTimeString = () => {
  //   return new Date().toLocaleString();
  // };

  const getDateTimeString = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, Mar...
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};



const handleExportPDF = () => {
  const doc = new jsPDF();

  doc.text("Bed Master Report (Grouped by Status)", 14, 15);

  // ✅ Group filteredBeds by bed_status
  const grouped = filteredBeds.reduce((acc, bed) => {
    if (!acc[bed.bed_status]) acc[bed.bed_status] = [];
    acc[bed.bed_status].push(bed);
    return acc;
  }, {});

  let startY = 25;

  // Loop through each group
  Object.keys(grouped).forEach((status) => {
    // Add a group header
    doc.setFontSize(12);
    doc.text(`Status: ${status}`, 14, startY);

    // Prepare rows
    const tableColumn = [ "Bed Number", "Bed Type", "Ward"];
    const tableRows = grouped[status].map((bed) => [

      bed.bed_code,
      bed.bedtype_name,
      bed.ward_name,
    ]);

    // Render table for this group
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: startY + 5,
      theme: "grid",
      styles: { fontSize: 10 },
      margin: { left: 14, right: 14 },
      didDrawPage: (data) => {
        startY = data.cursor.y + 10; // track position for next group
      },
    });
  });

  // Footer with timestamp
  const date = new Date().toLocaleString();
  doc.setFontSize(10);
  //doc.text(`Generated on: ${date}`, 14, doc.internal.pageSize.height - 10);
doc.text(
    `Generated on: ${formatDateTime(new Date())}`,
    14,
    doc.internal.pageSize.height - 10
  );
  doc.save(`BedMaster_Grouped_${Date.now()}.pdf`);
};


// const handleExportExcel = () => {
//   // ✅ Group filteredBeds by bed_status
//   const grouped = filteredBeds.reduce((acc, bed) => {
//     if (!acc[bed.bed_status]) acc[bed.bed_status] = [];
//     acc[bed.bed_status].push(bed);
//     return acc;
//   }, {});

//   let excelData = [];

//   // Title row
//   excelData.push(["Bed Availability Report"]);
//   excelData.push([]); // empty row

//   Object.keys(grouped).forEach((status) => {
//     // Group header
//     excelData.push([`Status: ${status}`]);

//     // Column headers
//     excelData.push(["Bed Number", "Bed Type", "Ward"]);

//     // Rows for this status
//     grouped[status].forEach((bed) => {
//       excelData.push([
//         bed.bed_code,
//         bed.bedtype_name,
//         bed.ward_name,
//       ]);
//     });

//     // Empty row after group
//     excelData.push([]);
//   });

//   excelData.push([`Generated: ${getDateTimeString()}`]);

//   // Convert to sheet
//   const ws = XLSX.utils.aoa_to_sheet(excelData);

//   // ✅ Apply formatting
//   // Title formatting
//   ws["A1"].s = {
//     font: { bold: true, sz: 16 },
//     alignment: { horizontal: "center" }
//   };

//   // Loop through rows to style "Status: ..." headers
//   Object.keys(ws).forEach((cell) => {
//     if (typeof ws[cell].v === "string" && ws[cell].v.startsWith("Status:")) {
//       ws[cell].s = {
//         font: { bold: true, sz: 14, color: { rgb: "FF0000" } },
//         alignment: { horizontal: "left" }
//       };
//     }
//   });

//   // Adjust column widths
//   ws["!cols"] = [
//     { wch: 15 }, // Bed Number
//     { wch: 20 }, // Bed Type
//     { wch: 20 }, // Ward
//   ];

//   // Create workbook
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "Beds");

//   // Save file
//   XLSX.writeFile(wb, `Bed_Availability_Grouped_${Date.now()}.xlsx`);
// };






  // const handleExportExcel = () => {
  //   const ws = XLSX.utils.json_to_sheet(
  //     filteredBeds.map((b) => ({
  //       "Ward Name": b.ward_name,
  //       "Bed Type": b.bedtype_name,
  //       "Bed Code": b.bed_code,
  //      // "Bed Charge": b.bed_charge,
  //       "Bed Status": b.bed_status,
  //     }))
  //   );
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Beds");

  //   XLSX.writeFile(wb, `Bed_Availability_${Date.now()}.xlsx`);
  // };

// const handleExportExcel = () => {
//   // ✅ Group filteredBeds by bed_status
//   const grouped = filteredBeds.reduce((acc, bed) => {
//     if (!acc[bed.bed_status]) acc[bed.bed_status] = [];
//     acc[bed.bed_status].push(bed);
//     return acc;
//   }, {});

//   // Excel data as array of arrays
//   let excelData = [];

//   // Title row
//   excelData.push(["Bed Availability Report"]);
 
//   excelData.push([]); // empty row

//   Object.keys(grouped).forEach((status) => {
//     // Group header
//     excelData.push([`Status: ${status}`]);

//     // Column headers
//     excelData.push([ "Bed Number", "Bed Type", "Ward"]);

//     // Rows for this status
//     grouped[status].forEach((bed) => {
//       excelData.push([
       
//         bed.bed_code,
//         bed.bedtype_name,
//         bed.ward_name,
//       ]);
//     });

//     // Empty row after group
//     excelData.push([]);
//   });
//  excelData.push([`Generated: ${getDateTimeString()}`]);
//   // Convert to sheet
//   const ws = XLSX.utils.aoa_to_sheet(excelData);

//   // Create workbook
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "Beds");

//   // Save file
//   XLSX.writeFile(wb, `Bed_Availability_Grouped_${Date.now()}.xlsx`);
// };



const handleExportExcel = () => {
  // ✅ Group filteredBeds by bed_status
  const grouped = filteredBeds.reduce((acc, bed) => {
    if (!acc[bed.bed_status]) acc[bed.bed_status] = [];
    acc[bed.bed_status].push(bed);
    return acc;
  }, {});

  let excelData = [];

  // Title row
  excelData.push([{ v: "Bed Availability Report", s: { font: { bold: true, sz: 16, color: { rgb: "1F4E78" } }, alignment: { horizontal: "center" } } }]);
  excelData.push([""]); // empty row

  Object.keys(grouped).forEach((status) => {
    // Group header (styled)
    excelData.push([{ v: `Status: ${status}`, s: { font: { bold: true, sz: 14, color: { rgb: "C00000" } } } }]);

    // Column headers (styled)
    excelData.push([
      { v: "Bed Number", s: { font: { bold: true }, fill: { fgColor: { rgb: "D9E1F2" } } } },
      { v: "Bed Type", s: { font: { bold: true }, fill: { fgColor: { rgb: "D9E1F2" } } } },
      { v: "Ward", s: { font: { bold: true }, fill: { fgColor: { rgb: "D9E1F2" } } } },
    ]);

    // Rows for this status
    grouped[status].forEach((bed) => {
      excelData.push([bed.bed_code, bed.bedtype_name, bed.ward_name]);
    });

    excelData.push([""]); // space after group
  });

  excelData.push([`Generated: ${getDateTimeString()}`]);

  // Convert to sheet
  const ws = XLSX.utils.aoa_to_sheet(excelData);

  // Set column widths
  ws["!cols"] = [{ wch: 15 }, { wch: 20 }, { wch: 20 }];

  // Create workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Beds");

  // Save file
  XLSX.writeFile(wb, `Bed_Availability_Grouped_${Date.now()}.xlsx`);
};


 const handlePrint = () => {
  const printWindow = window.open("", "_blank");

  // ✅ Group filteredBeds by bed_status
  const grouped = filteredBeds.reduce((acc, bed) => {
    if (!acc[bed.bed_status]) acc[bed.bed_status] = [];
    acc[bed.bed_status].push(bed);
    return acc;
  }, {});

  let htmlContent = `
    <html>
      <head>
        <title>Bed Availability Report</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          h2 { text-align: center; }
          h3 { margin-top: 20px; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          th, td { border: 1px solid #333; padding: 8px; text-align: left; }
          th { background: #f0f0f0; }
        </style>
      </head>
      <body>
        <h2>Bed Availability Report</h2>
       
  `;

  // Loop through each group
  Object.keys(grouped).forEach((status) => {
    htmlContent += `
      <h3>Status: ${status}</h3>
      <table>
        <thead>
          <tr>
          
            <th>Bed Number</th>
            <th>Bed Type</th>
            <th>Ward</th>
          </tr>
        </thead>
        <tbody>
    `;

    grouped[status].forEach((bed) => {
      htmlContent += `
        <tr>
        
          <td>${bed.bed_code}</td>
          <td>${bed.bedtype_name}</td>
          <td>${bed.ward_name}</td>
        </tr>
      `;
    });

    htmlContent += `
        </tbody>
      </table>
    `;
  });

  htmlContent += `
   <p>Generated: ${getDateTimeString()}</p>
      </body>
    </html>
  `;

  printWindow.document.write(htmlContent);
  printWindow.document.close();
  printWindow.print();
};

 
 
 
  return (
    <Card>
      <CardContent>
        <Heading headingtext="🛏️ Bed Availability Status" />
        
        {/* --- Bed Status Filter --- */}
        <Box sx={{ mt: 2, mb: 2, width: "250px" }}>
          <TextField
            select
            label="Filter by Bed Status"
            value={bedStatus}
            onChange={(e) => setBedStatus(e.target.value)}
            fullWidth
          >
            <MenuItem value="">All</MenuItem>
            {bedStatusOptions.map((status, idx) => (
              <MenuItem key={idx} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        {/* --- Beds Table --- */}
        <TableContainer
          component={Paper}
          sx={{ mt: 1, maxHeight: 400, overflowX: "auto" }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: "#106bb5ff", color: "#fff" }}>
              <TableRow>
                {[
                  "ward_name",
                  "bedtype_name",
                  "bed_code",
                //  "bed_charge",
                  "bed_status",
                ].map((head) => (
                  <TableCell key={head} sx={{ color: "#fff", fontWeight: "bold" }}>
                    <TableSortLabel
                      active={orderBy === head}
                      direction={orderBy === head ? order : "asc"}
                      onClick={() => handleRequestSort(head)}
                    >
                      {head.replace("_", " ").toUpperCase()}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {visibleRows.map((b) => (
                <TableRow key={b.bed_id} hover>
                  <TableCell>{b.ward_name}</TableCell>
                  <TableCell>{b.bedtype_name}</TableCell>
                  <TableCell>{b.bed_code}</TableCell>
                  {/* <TableCell>{b.bed_charge}</TableCell> */}
                  <TableCell>{b.bed_status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredBeds.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        {/* --- Export Buttons --- */}
        <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
          <Button variant="contained" color="primary" onClick={handleExportPDF}>
            Export to PDF
          </Button>
          <Button variant="contained" color="success" onClick={handleExportExcel}>
            Export to Excel
          </Button>
          <Button variant="contained" color="secondary" onClick={handlePrint}>
            Print
          </Button>
        </Box>

        {/* Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
        </Snackbar>
      </CardContent>
    </Card>
  );
};

export default BedAvailability;
